import {
    customIconSmartphoneOdido,
    customIconSmartphoneKpn,
    deanCloudIcon,
    deanInternetIcon,
    forbiddenIcon,
    warningIcon,
    deleteIcon,
    clockIcon,
    checkmarkIcon,
    calendarTimeIcon,
    customIconPhoneCall,
} from '@deanone/dean-components';
import statusIcon from '@/assets/svg/status.svg';
import wonIcon from '@/assets/svg/won.svg';
import {ServiceTypeEnum} from "@/enums/ServiceTypeEnum";

export const servicesStringToIcons = (services: string|string[]): any[] => {
    if (typeof services === 'string') {
        services = services.split(',');
    }

    return services.map((service: string) => {
        let serviceIcon: string;
        switch (service) {
            case ServiceTypeEnum.MOBILE_ODIDO: case 'dean-mobile':
                serviceIcon = customIconSmartphoneOdido;
                break;
            case ServiceTypeEnum.MOBILE_KPN: case 'dean-mobile-kpn':
                serviceIcon = customIconSmartphoneKpn;
                break;
            case ServiceTypeEnum.CLOUD: case 'dean-cloud':
                serviceIcon = deanCloudIcon;
                break;
            case ServiceTypeEnum.CONNECTION: case 'dean-internet':
                serviceIcon = deanInternetIcon;
                break;
            case ServiceTypeEnum.SIP_TRUNK: case 'dean-sip-trunk':
                serviceIcon = customIconPhoneCall;
                break;
            default:
                serviceIcon = forbiddenIcon;
        }
        return serviceIcon;
    });
};

export const statusStringToIcons = (statuses: string|string[]): any[] => {
    if (typeof statuses === 'string') {
        statuses = statuses.split(',');
    }

    return statuses.map((status: string) => {
        let currStatusIcon: any;

        switch (status) {
            case 'status':
                currStatusIcon = statusIcon;
                break;
            case 'forbidden':
                currStatusIcon = forbiddenIcon;
                break;
            case 'warning':
                currStatusIcon = warningIcon;
                break;
            case 'won':
                currStatusIcon = wonIcon;
                break;
            case 'delete':
                currStatusIcon = deleteIcon;
                break;
            case 'clock':
                currStatusIcon = clockIcon;
                break;
            case 'checkmark':
                currStatusIcon = checkmarkIcon;
                break;
            case 'calendar-time':
                currStatusIcon = calendarTimeIcon;
                break;
            default:
                currStatusIcon = forbiddenIcon;
        }

        return currStatusIcon;
    });
};
